import routerOptions0 from "/home/app/pd-awards-frontend/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/home/app/pd-awards-frontend/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}